/**
 * MODULE: SalesTargetFormCatalogBridge.tsx
 * PURPOSE: Route assistant sales_target_self form_catalog to generative quota modal.
 */

import { requestOpenSalesTargetSet } from '@shared/lib/frontend/utils/salesTargetSetBridge';
import type { FormRequest } from '../../hooks/assistant/types';
import { extractSalesTargetPrefillFromFormRequest } from './assistantFormRequestUtils';

type Props = {
  formRequest: FormRequest;
  onCancel: () => void;
  disabled?: boolean;
};

export function SalesTargetFormCatalogBridge({ formRequest, onCancel, disabled = false }: Props) {
  const prefill = extractSalesTargetPrefillFromFormRequest(formRequest);

  return (
    <div className="space-y-3" data-testid="assistant-sales-target-golden-path">
      <h3 className="text-sm font-semibold text-gray-900 dark:text-white">Set your quota</h3>
      <div
        className="rounded-lg border border-violet-200 bg-violet-50/80 p-3 dark:border-violet-900/50 dark:bg-violet-950/30"
        data-testid="assistant-sales-target-golden-path-banner"
      >
        <p className="text-xs text-violet-900 dark:text-violet-100">
          Use the AI-assisted quota planner — the sidebar assistant stays grounded while you confirm
          amount and period. Locked CRM quotas cannot be edited here.
        </p>
        <button
          type="button"
          disabled={disabled}
          onClick={() => {
            requestOpenSalesTargetSet({ prefill, coachInAssistant: true });
            onCancel();
          }}
          className="mt-2 w-full rounded-lg bg-violet-600 px-3 py-2 text-sm font-medium text-white transition hover:bg-violet-700 disabled:opacity-50"
          data-testid="assistant-sales-target-open-modal"
        >
          Open quota planner
        </button>
      </div>
    </div>
  );
}
